import React from "react";

const Footer = () => {
  return (
    <div className="footer-container">
      <div>
        <div className="footer-titre">© Elize sokolova</div>
        <div className="footer-droits">tous droits réservés</div>
        <div className="footer-mentions">Mentions légales</div>
      </div>
      <div>
        <div className="footer-mail">
          <a href="mailto:elizesokolova@gmail.com">E-MAIL</a>
        </div>
        <div className="footer-links">
          <a href="http://www.instagram.com/elize.sokolova">
            <img
              src={`${process.env.REACT_APP_DATA_URL}/img/logo-insta.png`}
              alt="Instagram"
              width="30"
              height="30"
            />
          </a>
          <a href="https://www.linkedin.com/in/elize-sokolova-69a758172/">
            <img
              src={`${process.env.REACT_APP_DATA_URL}/img/logo-linkedin.png`}
              alt="LinkedIn"
              width="30"
              height="30"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
